
function AddressDisplay({ address }) {
  const { neighborhood, unitNo, formatted } = address || {};
  
  return `${neighborhood?`[${neighborhood}] `:''}${unitNo?`${unitNo}, `:''}${formatted||''}`;
}

export default AddressDisplay;
